webpackJsonp([1],{

/***/ "7Fpb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Xinput_vue__ = __webpack_require__("tIiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_28a31e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Xinput_vue__ = __webpack_require__("hAAA");
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Xinput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_28a31e26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Xinput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E4LH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = validatePhone;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateNull;
/* harmony export (immutable) */ __webpack_exports__["f"] = validateVerify;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateEmail;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateCode;
/* harmony export (immutable) */ __webpack_exports__["e"] = validatePwd;
/* unused harmony export isWscnEmail */
/* unused harmony export validateURL */
/* unused harmony export validateLowerCase */
/* unused harmony export validateUpperCase */
/* unused harmony export validatAlphabets */

/*验证手机号是否正确*/
function validatePhone(str) {
  var reg = /^1[0-9]{10}$/;
  return reg.test(str);
}
/*为空验证*/

function validateNull(str) {
  if (str) {
    return true;
  }
  return false;
}
function validateVerify(str) {
  var reg = /^[0-9A-Za-z]{4,4}$/;
  return reg.test(str);
}
function validateEmail(str) {
  var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
  return reg.test(str);
}

function validateCode(str) {
  var reg = /^[0-9]{6,6}$/;
  return reg.test(str);
}
//密码6-16位
function validatePwd(str) {
  var reg = /^[0-9A-Za-z]{6,16}$/;
  return reg.test(str);
}

/* 是否是公司邮箱*/
function isWscnEmail(str) {
  var reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@wallstreetcn\.com$/i;
  return reg.test(str.trim());
}

/* 合法uri*/
function validateURL(textval) {
  var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 验证key*/
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母*/
function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/***/ }),

/***/ "EZXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Pinput_vue__ = __webpack_require__("YS/T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_4962e7f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Pinput_vue__ = __webpack_require__("RNws");
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Pinput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_4962e7f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Pinput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GQnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_c('div',{staticStyle:{"position":"fixed","top":"0","background-color":"#228EE6","width":"100%","z-index":"5"}},[_c('div',{staticClass:"container-fluid header"},[_vm._v("初始设置")]),_vm._v(" "),_c('a',{staticClass:"icon-back",on:{"click":function($event){_vm.back()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"container-fluid main"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('Xinput',{attrs:{"x-class":_vm.cname_class,"x-cola":_vm.col12,"x-colb":_vm.cols22,"x-colc":_vm.cols78,"x-type":_vm.type.text,"x-maxlength":_vm.cname_length,"x-name":_vm.cname_name,"x-placeholder":_vm.cname_Placeholder,"x-msg":_vm.cname_msg,"x-val":_vm.cname},on:{"input":_vm.handleCname}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('Xinput',{attrs:{"x-class":_vm.job_class,"x-cola":_vm.col12,"x-colb":_vm.cols22,"x-colc":_vm.cols78,"x-type":_vm.type.text,"x-maxlength":_vm.job_length,"x-name":_vm.job_name,"x-placeholder":_vm.job_Placeholder,"x-msg":_vm.job_msg,"x-val":_vm.job},on:{"input":_vm.handleJob}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('Xinput',{attrs:{"x-class":_vm.name_class,"x-cola":_vm.col12,"x-colb":_vm.cols22,"x-colc":_vm.cols78,"x-type":_vm.type.text,"x-maxlength":_vm.name_length,"x-name":_vm.name_name,"x-placeholder":_vm.name_Placeholder,"x-msg":_vm.name_msg,"x-val":_vm.name},on:{"input":_vm.handleName}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('Xinput',{attrs:{"x-class":_vm.email_class,"x-cola":_vm.col12,"x-colb":_vm.cols22,"x-colc":_vm.cols78,"x-type":_vm.type.email,"x-name":_vm.email_name,"x-placeholder":_vm.email_Placeholder,"x-msg":_vm.email_msg,"x-val":_vm.email},on:{"blur":_vm.handleEmail}})],1),_vm._v(" "),_c('Pinput',{attrs:{"x-class":_vm.pwd_class,"x-type":_vm.type.passworld,"x-name":_vm.pwd_name,"x-placeholder":_vm.pwd_Placeholder,"x-msg":_vm.pwd_msg,"x-val":_vm.pwd},on:{"blur":_vm.handlePwd,"input":_vm.handlePwd2}}),_vm._v(" "),_c('div',{staticClass:"form-group provision"},[_c('input',{staticClass:"magic-checkbox",attrs:{"checked":"","type":"checkbox","name":"layout","id":"c1"},domProps:{"value":_vm.check_value}}),_vm._v(" "),_c('label',{attrs:{"for":"c1"},on:{"click":function($event){_vm.changeCheckbox()}}},[_vm._v("已阅读并同意："),_c('a',{on:{"click":function($event){_vm.goService()}}},[_vm._v("销售易使用条款")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{class:_vm.submit_btn_class,staticStyle:{"width":"100%"},attrs:{"type":"button","disabled":_vm.btn_disabled},on:{"click":function($event){_vm.dosubmit();}}},[_c('div',{staticClass:"ladda-label"},[_vm._v("提交资料")])])])],1)]),_vm._v(" "),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid subtitle"},[_vm._v("补全信息，您将获得"),_c('span',{staticClass:"hightlight-orange"},[_vm._v("30天")]),_vm._v("的免费试用时间")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JpB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xXYo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_5fed97f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("VCFC");
function injectStyle (ssrContext) {
  __webpack_require__("ZE/6")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_5fed97f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L6TL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("OCI+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_0b10ec3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ssoJ");
function injectStyle (ssrContext) {
  __webpack_require__("syy9")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_0b10ec3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("ntk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_toast_index_js__ = __webpack_require__("E10C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_theme_css__ = __webpack_require__("TXXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_theme_css__);


/* import 'babel-polyfill' */



/* import jquery from 'jquery' */


/*import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'*/

/*import './assets/jquery.min.js'*/

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.HOST = '/json';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_toast_index_js__["a" /* default */]);

/* Vue.use(jquery)  */

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OCI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "RNws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cols-22",domProps:{"innerHTML":_vm._s(_vm.xName)}}),_vm._v(" "),_c('div',{staticClass:"cols-78"},[(_vm.seen)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"child",class:_vm.xClass,attrs:{"type":"text","placeholder":_vm.xPlaceholder},domProps:{"value":(_vm.val)},on:{"focus":function($event){_vm.focus()},"blur":function($event){_vm.blur(),_vm.onchange()},"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){_vm.onchange2()}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"child",class:_vm.xClass,attrs:{"type":"password","placeholder":_vm.xPlaceholder},domProps:{"value":(_vm.val)},on:{"focus":function($event){_vm.focus()},"blur":function($event){_vm.blur(),_vm.onchange()},"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){_vm.onchange2()}]}}),_vm._v(" "),_c('span',{staticClass:"col-12 label label-danger"},[_vm._v(_vm._s(_vm.xMsg))]),_vm._v(" "),_c('span',{class:_vm.icon_eye,on:{"click":function($event){_vm.showpwd()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TXXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VCFC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container service"},[_c('div',{staticStyle:{"position":"fixed","top":"0","background-color":"#228EE6","width":"100%","z-index":"5"}},[_c('div',{staticClass:"container-fluid header"},[_vm._v("初始设置")]),_vm._v(" "),_c('a',{staticClass:"icon-back",on:{"click":function($event){_vm.back()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid subtitle"},[_vm._v("注册成功后，您将获得"),_c('span',{staticClass:"hightlight-orange"},[_vm._v("30天")]),_vm._v("的免费试用时间")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid main"},[_c('h2',[_vm._v("销售易服务条款")]),_vm._v(" "),_c('div',{staticClass:"reg-form help-form service-form"},[_c('h4',[_vm._v("约定")]),_vm._v(" "),_c('p',[_vm._v("\r\n            1. 本合约是销售易用户（包括使用的个人和其代表的企业）与销售易运营企业北京仁科互动网络技术有限公司之间的法律契约，用户注册销售易服务即代表接受本条款的约束，并自注册成功之时即成为本合约一方、受该使用条款约束。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n            2. 下文中的“销售易”指企业社会化协作与销售管理平台“销售易”或其运营企业北京仁科互动网络技术有限公司。\r\n        ")]),_vm._v(" "),_c('h4',[_vm._v("合法使用")]),_vm._v(" "),_c('p',[_vm._v("1. 销售易服务限于提供给用户用作正常和合法的业务。")]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("1.1 用户不得利用销售易服务制作、上传、发布、传播如下法律、法规和政策禁止的内容：")]),_vm._v(" "),_c('ul',{staticStyle:{"margin-bottom":"30px"}},[_c('li',[_vm._v("反对宪法所确定的基本原则的；")]),_vm._v(" "),_c('li',[_vm._v("危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；")]),_vm._v(" "),_c('li',[_vm._v("损害国家荣誉和利益的；")]),_vm._v(" "),_c('li',[_vm._v("煽动民族仇恨、民族歧视，破坏民族团结的；")]),_vm._v(" "),_c('li',[_vm._v("破坏国家宗教政策，宣扬邪教和封建迷信的；")]),_vm._v(" "),_c('li',[_vm._v("散布谣言，扰乱社会秩序，破坏社会稳定的；")]),_vm._v(" "),_c('li',[_vm._v("散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；")]),_vm._v(" "),_c('li',[_vm._v("侮辱或者诽谤他人，侵害他人合法权益的；")]),_vm._v(" "),_c('li',[_vm._v("含有法律、法规和政策禁止的其他内容的信息；")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("1.2 用户不得利用销售易服务进行如下行为：")]),_vm._v(" "),_c('ul',{staticStyle:{"margin-bottom":"30px"}},[_c('li',[_vm._v("含有任何性或性暗示或其他低俗类信息的；")]),_vm._v(" "),_c('li',[_vm._v("发送骚扰、垃圾广告或信息的；")]),_vm._v(" "),_c('li',[_vm._v("涉及他人隐私、个人信息或资料的；")]),_vm._v(" "),_c('li',[_vm._v("侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；")]),_vm._v(" "),_c('li',[_vm._v("含有其他干扰销售易正常运营和侵犯其他用户或其他第三方合法权益内容的信息；")]),_vm._v(" "),_c('li',[_vm._v("利用销售易账户从事任何违法犯罪活动的；")]),_vm._v(" "),_c('li',[_vm._v("对销售易产品进行了任何形式的对其他第三方的再授权使用、销售或转让；")]),_vm._v(" "),_c('li',[_vm._v("为设计开发竞争产品对销售易产品进行任何形式的反向工程，或抄袭模仿销售易的设计；")]),_vm._v(" "),_c('li',[_vm._v("其他违反法律法规规定、侵犯其他用户合法权益、干扰销售易产品正常运营或销售易公司未明示授权的行为；")])]),_vm._v(" "),_c('p',[_vm._v("\r\n            1.3 如果用户使用销售易产品从事上述1.1条及1.2条的行为，销售易有权随时停止服务、并要求用户赔偿由此造成的损失。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n            2. 销售易使用用户所拥有的电子邮件地址、手机号码、用户名等作为用户权证的唯一识别信息。当免费试用期过后，未付费用户将不再享有销售易的服务，销售易有权随时删除该用户的所有用户数据。\r\n        ")]),_vm._v(" "),_c('h4',[_vm._v("数据和程序归属权")]),_vm._v(" "),_c('p',[_vm._v("1. 用户在销售易平台创建的独创性数据归属用户所有，用户有权对其所创建的数据进行任何形式的处置，包括从平台中复制、导出和删除。")]),_vm._v(" "),_c('p',[_vm._v("\r\n            2. 销售易的应用程序、源代码、LOGO、界面设计、应用程序编程接口（API）所关联的所有知识产权均归属北京仁科互动网络技术有限公司。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n           3. 依照明确的服务约定，销售易在用户未继续付费且未继续使用达到6个月后，销售易有权将用户数据从平台上删除，而无需向用户承担任何赔偿责任。该数据包括但不限于用户账户信息、用户使用过程中创建的独创性使用数据。删除的数据将无法从平台上导出或恢复。\r\n        ")]),_vm._v(" "),_c('h4',[_vm._v("用户隐私权")]),_vm._v(" "),_c('p',[_vm._v("\r\n            1. 销售易应当从组织结构和技术角度尽最大努力保护用户数据安全，只根据用户在网站上或APP移动端的行为指示来分发用户的信息。未经用户同意，销售易不会将用户产生的具体数据提供任何无关第三方，但法律法规另有规定的除外。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("2. 销售易保留使用汇总统计性信息的权利，这些信息应当是匿名，且不是针对特定用户的。")]),_vm._v(" "),_c('p',[_vm._v("\r\n            3.用户如果需要销售易全面删除其在销售易上创建的用户数据，需要书面向销售易提出申请，并在申请书中加盖公司公章。\r\n        ")]),_vm._v(" "),_c('h4',[_vm._v("服务连续性")]),_vm._v(" "),_c('p',[_vm._v("\r\n            1. 销售易将尽最大努力保障软件平台的连续可靠运行。对于付费用户，销售易承诺98%以上的正常在线率，对于未付费用户，销售易不提供任何保证或承担任何形式的赔偿责任。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n            2. 销售易将尽最大努力保障用户数据的安全备份。对于付费用户，销售易承诺在有任何用户数据因服务器存储设备损坏时以最快的速度从最近的备份中恢复数据，但无法承诺100%的数据恢复，对因数据丢失带来的其他连带或间接损失不承担任何责任；对于未付费用户，销售易不提供恢复服务。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("3. 在发生需要从备份文件中恢复数据的情形时，销售易通常需要4至48小时完成，在此时间范围内的数据恢复视作服务是连续的。")]),_vm._v(" "),_c('p',[_vm._v("4. 因重大自然灾害、战争等其他不可抗力导致的销售易服务中断和长时间终止，销售易不承担赔偿责任。")]),_vm._v(" "),_c('h4',[_vm._v("条款修订")]),_vm._v(" "),_c('p',[_vm._v("\r\n            1.销售易有权随时对本合约的条款进行修订，并在修订生效日前一个工作日更新在销售易网站。若用户继续使用销售易服务，则意味着同意并自愿遵守修改后的使用条款。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("2.修订的条款始终在销售易官方网站公示。")]),_vm._v(" "),_c('h4',[_vm._v("其他")]),_vm._v(" "),_c('p',[_vm._v("\r\n           本合约条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。本合约的成立、生效、履行、解释及纠纷解决，都适用于中华人民共和国的法律。本合约的签订地为北京。\r\n        ")]),_vm._v(" "),_c('p',[_vm._v("\r\n           如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。如果在一方向其他方送达要求开始协商的书面通知后六十天内未能通过协商解决争议，那么任何一方均可将争议提交至北京仲裁委员会，按照其届时有效的规则进行仲裁。仲裁裁决是终局的，对各方均有约束力，不可上诉。仲裁费用由败诉方承担，除非仲裁裁决另有规定。当任何争议发生时以及在对任何争议进行仲裁时，除争议事项外，各方应继续行使各自在本协议项下的其他权利，履行各自在本协议项下的其他义务。\r\n        ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p'),_vm._v(" "),_c('h3',[_vm._v("仁科互动公司保留本服务条款的解释权。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XF8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("psZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_1eb357fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cYVf");
function injectStyle (ssrContext) {
  __webpack_require__("g5vQ")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_1eb357fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YS/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Pinput',
	props: ['xName', 'xClass', 'xMsg', 'xPlaceholder', 'xType', 'xVal'],

	data: function data() {
		return {
			val: this.xVal,
			seen: true,
			icon_eye: "icon-eye"
		};
	},

	methods: {
		//处理手机号表单状态
		blur: function blur() {
			var me = this;
			setTimeout(function () {
				//显示字符
			}, 1);
		},

		focus: function focus() {},
		onchange: function onchange() {
			this.$emit('blur', this.val.trim());
		},
		onchange2: function onchange2() {
			if (this.val.length > 16) {
				this.val = this.val.substring(0, 16);
			}
			this.$emit('input', this.val.trim());
		},
		showpwd: function showpwd() {
			if (this.icon_eye == "icon-eye") {
				this.icon_eye = "icon-eye-n";
				this.seen = !this.seen;
				this.$refs.child.focus();
			} else {
				this.icon_eye = "icon-eye";
				this.seen = !this.seen;
				this.$refs.child.focus();
			}
		}

	}
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("ntk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("41Db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_register_index__ = __webpack_require__("bqOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_init_index__ = __webpack_require__("dWTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_exist_index__ = __webpack_require__("XF8T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_service_index__ = __webpack_require__("JpB7");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  /*  mode: 'history',*/
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_register_index__["a" /* default */],
    name: 'register'
  }, {
    path: '/init',
    component: __WEBPACK_IMPORTED_MODULE_3__views_init_index__["a" /* default */],
    name: 'init'
  }, {
    path: '/exist',
    component: __WEBPACK_IMPORTED_MODULE_4__views_exist_index__["a" /* default */],
    name: 'exist'
  }, {
    path: '/service',
    component: __WEBPACK_IMPORTED_MODULE_5__views_service_index__["a" /* default */],
    name: 'service'
  }]
}));

/***/ }),

/***/ "ZE/6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bqOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yZtf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_8f172a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("eZ8x");
function injectStyle (ssrContext) {
  __webpack_require__("ytjV")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_8f172a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cYVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_c('div',{staticClass:"container-fluid header"},[_vm._v("注册")]),_vm._v(" "),_c('div',{staticClass:"container-fluid main exist"},[_c('div',{staticClass:"exist_icon"},[_c('div',{class:_vm.page_img})]),_vm._v(" "),_c('div',{staticClass:"exist_title"},[_vm._v(_vm._s(_vm.page_title))]),_vm._v(" "),_c('div',{staticClass:"exist_content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.page_content)}}),_vm._v(" "),_c('a',{staticClass:"btn btn-blue btn-large",staticStyle:{"margin-top":"20px"},on:{"click":function($event){_vm.checSystem()}}},[_vm._v("打开销售易APP")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dWTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("pnN+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_1f599f3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GQnR");
function injectStyle (ssrContext) {
  __webpack_require__("L6TL")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_1_1_13_vux_loader_src_script_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_1f599f3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_1_1_13_vux_loader_src_template_loader_js_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eZ8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid main"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group "},[_c('Xinput',{attrs:{"x-class":_vm.tel_class,"x-cola":_vm.col12,"x-colb":_vm.cols22,"x-colc":_vm.cols78,"xType":_vm.type.tel,"x-maxlength":11,"x-name":_vm.tel_name,"x-placeholder":_vm.tel_Placeholder,"x-msg":_vm.tel_msg,"x-val":_vm.tel},on:{"input":_vm.handleTel,"blur":_vm.handleTelBlur}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('Xinput',{ref:"verify",attrs:{"x-class":_vm.verify_class,"x-cola":_vm.col8,"x-colb":_vm.col4,"x-colc":_vm.col8,"xType":_vm.type.text,"x-maxlength":4,"x-name":_vm.verify_name,"x-placeholder":_vm.verify_Placeholder,"x-msg":_vm.verify_return,"x-val":_vm.verify_value},on:{"input":_vm.handleVerify,"blur":_vm.handleVerifyBlur}}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('img',{staticClass:"captcha-img",attrs:{"src":_vm.verify_img},on:{"click":function($event){_vm.getCaptcha();}}})])],1),_vm._v(" "),_c('div',{staticClass:"form-group "},[_c('Xinput',{attrs:{"x-class":_vm.code_class,"x-cola":_vm.col8,"x-colb":_vm.col4,"x-colc":_vm.col8,"xType":_vm.type.tel,"x-maxlength":6,"x-name":_vm.code_name,"x-placeholder":_vm.code_Placeholder,"x-msg":_vm.code_return,"x-val":_vm.code_value},on:{"input":_vm.handleCode,"blur":_vm.handleCodeBlur}}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('button',{class:_vm.code_btn_class,staticStyle:{"width":"80%","float":"right"},attrs:{"disabled":_vm.code_btn_disabled,"type":"button"},on:{"click":function($event){_vm.sendCaptch()}}},[_vm._v(_vm._s(_vm.code_btn_value))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{class:_vm.submit_btn_class,staticStyle:{"width":"100%"},attrs:{"type":"button","disabled":_vm.submit_btn_disabled},on:{"click":function($event){_vm.doSubmit()}}},[_c('div',{staticClass:"ladda-label"},[_vm._v("下一步")])])]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"fixed","top":"0","background-color":"#228EE6","width":"100%","z-index":"5"}},[_c('div',{staticClass:"container-fluid header"},[_vm._v("注册")]),_vm._v(" "),_c('div',{staticClass:"container-fluid subtitle"},[_vm._v("注册成功后，您将获得"),_c('span',{staticClass:"hightlight-orange"},[_vm._v("30天")]),_vm._v("的免费试用时间")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group footer"},[_c('p',[_vm._v("咨询电话："),_c('a',{attrs:{"href":"tel:4000122980"}},[_vm._v("4000122980")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g5vQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKqU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hAAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.xCola},[_c('label',{class:_vm.xColb,domProps:{"innerHTML":_vm._s(_vm.xName)}}),_vm._v(" "),_c('div',{class:_vm.xColc},[(_vm.xType == 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"child",class:_vm.xClass,attrs:{"type":"tel","maxlength":_vm.xMaxlength,"placeholder":_vm.xPlaceholder},domProps:{"value":(_vm.val)},on:{"keyup":function($event){_vm.keyup()},"focus":function($event){_vm.focus()},"blur":function($event){_vm.blur()},"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){_vm.onchange()}]}}):(_vm.xType == 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"child",class:_vm.xClass,attrs:{"type":"email","placeholder":_vm.xPlaceholder},domProps:{"value":(_vm.val)},on:{"keyup":function($event){_vm.keyup()},"focus":function($event){_vm.focus()},"blur":function($event){_vm.blur()},"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){_vm.onchange()}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"child",class:_vm.xClass,attrs:{"type":"text","maxlength":_vm.xMaxlength,"placeholder":_vm.xPlaceholder},domProps:{"value":(_vm.val)},on:{"keyup":function($event){_vm.keyup()},"focus":function($event){_vm.focus()},"blur":function($event){_vm.blur()},"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},function($event){_vm.onchange()}]}}),_vm._v(" "),_c('span',{staticClass:"col-12 label label-danger"},[_vm._v(_vm._s(_vm.xMsg))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon_remove),expression:"icon_remove"}],staticClass:"icon-remove",on:{"click":function($event){_vm.clear()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "khnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__("8NEE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ "lW0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pnN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_validate__ = __webpack_require__("E4LH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Xinput_vue__ = __webpack_require__("7Fpb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pinput_vue__ = __webpack_require__("EZXu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'init',
  data: function data() {
    return {
      //col-12
      col3: "col-3",
      col4: "col-4",
      col5: "col-5",
      col6: "col-6",
      col8: "col-8",
      col9: "col-9",
      col12: "col-12",

      //cols-100
      cols22: "cols-22",
      cols78: "cols-78",

      //:disabled="btn_disabled
      btn_disabled: true,
      submit_btn_class: "btn btn-blue",
      check_value: true,

      //公司名
      cname: "",
      cname_msg: '',
      cname_name: '公司名<span class="label label-danger">*</span>',
      cname_class: "form-control",
      cname_Placeholder: "必填",
      cname_length: 30,

      //職位
      job: "",
      job_msg: '',
      job_name: '职位<span class="label label-danger">*</span>',
      job_class: "form-control",
      job_Placeholder: "必填",
      job_length: 20,

      //姓名
      name: "",
      name_msg: '',
      name_name: '姓名<span class="label label-danger">*</span>',
      name_class: "form-control",
      name_Placeholder: "必填",
      name_length: 10,

      //邮箱
      email: "",
      email_msg: '',
      email_name: '邮箱',
      email_class: "form-control",
      email_Placeholder: "将获取更多产品信息",

      //密码
      pwd: "",
      pwd_msg: '',
      pwd_name: '密码<span class="label label-danger">*</span>',
      pwd_class: "form-control",
      pwd_Placeholder: "6-16位数字或字符组合",

      //
      type: {
        number: "number",
        text: "text",
        email: "email",
        passworld: "password"
      }
    };
  },

  created: function created() {
    //初始化执行的方法
    this.code_value = this.$route.params.code_value;
    this.tel = this.$route.params.tel;
    this.cname = this.$route.params.cname;
    this.job = this.$route.params.job;
    this.name = this.$route.params.name;
    this.email = this.$route.params.email;

    /*    console.log(
          "cname :"+ this.cname +
          "job :"+ this.job +
          "name :"+ this.name +
          "email :"+ this.email +
          "code_value :"+ this.code_value +
          "tel :"+ this.tel
          )
    */

    if (this.$route.params.email) {
      this.email = this.$route.params.email;
    } else {
      this.email = "";
    }
  },
  components: {
    Pinput: __WEBPACK_IMPORTED_MODULE_2__components_Pinput_vue__["a" /* default */], Xinput: __WEBPACK_IMPORTED_MODULE_1__components_Xinput_vue__["a" /* default */]
  },
  methods: {
    handleCname: function handleCname(str) {
      this.cname = str;
      if (this.cname) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.cname)) {
          this.cname_class = "form-control input-error";
          this.cname_msg = "公司名不能为空";
        } else {
          this.cname_msg = "";
          this.cname_class = "form-control";
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleJob: function handleJob(str) {
      this.job = str;
      if (this.job) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.job)) {
          this.job_class = "form-control input-error";
          this.job_msg = "职位不能为空";
        } else {
          this.job_msg = "";
          this.job_class = "form-control";
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleName: function handleName(str) {
      this.name = str;
      if (this.name) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.name)) {
          this.name_class = "form-control input-error";
          this.name_msg = "姓名不能为空";
        } else {
          this.name_msg = "";
          this.name_class = "form-control";
        }
        this.doCheck();
      }
      this.doCheck();
    },
    handleEmail: function handleEmail(str) {
      this.email = str;
      if (this.email) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["b" /* validateEmail */])(this.email)) {
          this.email_class = "form-control input-error";
          this.email_msg = "邮件格式不对";
        } else {
          this.email_class = "form-control";
          this.email_msg = "";
        }
      } else {
        this.email_class = "form-control";
        this.email_msg = "";
        this.doCheck();
      }
    },
    handlePwd: function handlePwd(str) {

      this.pwd = str;
      if (this.pwd == "") {
        this.pwd_class = "form-control";
        this.pwd_msg = "";
      } else {
        if (this.pwd) {
          if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["e" /* validatePwd */])(this.pwd)) {
            this.pwd_class = "form-control input-error";
            this.pwd_msg = "密码格式不对";
          } else {
            this.pwd_class = "form-control";
            this.pwd_msg = "";
          }
          this.doCheck();
        } else {
          this.pwd_class = "form-control";
          this.pwd_msg = "";
          this.doCheck();
        }
      }
    },
    handlePwd2: function handlePwd2(str) {
      this.pwd = str;

      if (this.pwd.length >= "6") {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["e" /* validatePwd */])(this.pwd)) {
          this.pwd_class = "form-control input-error";
          this.pwd_msg = "密码格式不对";
        } else {
          this.pwd_class = "form-control";
          this.pwd_msg = "";
        }
      }
      this.doCheck();
    },
    goService: function goService() {

      this.$router.push({
        name: 'service',
        params: {
          cname: this.cname,
          job: this.job,
          name: this.name,
          email: this.email,
          code_value: this.code_value,
          tel: this.tel }
      });
    },
    back: function back() {
      var tel = this.$route.params.tel;

      this.$router.push({
        name: 'register',
        params: { tel: tel } });
    },
    changeCheckbox: function changeCheckbox() {

      if (this.check_value == false) {
        this.check_value = true;
      } else {
        this.check_value = false;
      }
    },
    doCheck: function doCheck() {

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.cname) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.job) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.name) && this.pwd.length >= 6) {
        this.btn_disabled = false;
      } else {
        this.btn_disabled = true;
      }
    },
    dosubmit: function dosubmit() {

      if (this.check_value == true) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.cname) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.job) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["c" /* validateNull */])(this.name) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["e" /* validatePwd */])(this.pwd)) {
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_validate__["b" /* validateEmail */])(this.email) || this.email == "") {

            var self = this;
            self.btn_disabled = true;

            var tel = this.$route.params.tel;
            var captcha = this.$route.params.code_value;

            /* var url = this.HOST + "/json/global_register/initialize.action?loginName=" + tel + "&captcha=" + captcha + 
             "&password=" + self.pwd + "&app['company']=" + self.cname + "&app['title']=" + self.job + "&app['userName']=" + self.name + "&app['contact']=" + self.email ;  */
            var url = "/json/global_register/initialize.action?loginName=" + tel + "&captcha=" + captcha + "&password=" + self.pwd + "&app['company']=" + self.cname + "&app['title']=" + self.job + "&app['userName']=" + self.name + "&app['contact']=" + self.email;
            $.ajax({
              url: url,
              type: 'GET',
              timeout: 10000,
              error: function error() {
                self.$vux.toast.show({ text: '连接超时', type: 'text', time: 4000 });
              },
              success: function success(responseText) {

                var status = responseText.status;
                var statusText = responseText.statusText;

                if (status == 0) {
                  self.$router.push({ name: 'exist', params: { tel: tel } });
                } else if (status == 101005) {
                  self.$vux.toast.show({ text: '验证码失效', type: 'text', time: 4000 });
                  self.btn_disabled = false;
                } else if (status == 101001) {
                  self.$vux.toast.show({ text: '验证码错误', type: 'text', time: 4000 });
                  self.btn_disabled = false;
                } else if (status == 100000) {
                  self.$vux.toast.show({ text: '手机号或验证码为空', type: 'text', time: 4000 });
                  self.btn_disabled = false;
                }
              } });
          } else {

            this.handleEmail(this.email);
          }
        } else {
          this.handleCname(this.cname);
          this.handleJob(this.job);
          this.handleName(this.name);
          this.handleEmail(this.email);
        }
      } else {
        this.$vux.toast.show({ text: '请仔细阅读使用条款', type: 'text', time: 4000 });
      }
    }
  }
});

/***/ }),

/***/ "psZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'exist',
    data: function data() {
        return {
            page_img: "error",
            page_title: "",
            page_content: "",
            tel: "",
            accountStatus: ""
        };
    },

    created: function created() {
        this.tel = this.$route.params.tel;
        this.accountStatus = this.$route.params.accountStatus;
        this.changeContent();
        //初始化执行的方法

        var send_track = function send_track(cs_obj) {
            var url = document.URL;
            var query = '';
            if (url.indexOf("?") != -1) {
                query = url.substring(url.indexOf("?") + 1, url.length);
            }
            var eventTime = new Date().valueOf();
            var eventType = 'page';
            var domain = window.location.hostname;
            console.log(domain);
            var path = window.location.pathname;
            var refer = document.referrer;
            var platform = 'web';
            var title = document.title;
            var post_obj = {
                'query': query,
                'eventTime': eventTime,
                'eventType': eventType,
                'domain': domain,
                'path': path,
                'refer': refer,
                'platform': platform,
                'title': title
            };
            if (cs_obj) {
                jQuery.extend(post_obj, cs_obj);
            }
            jQuery.ajax({
                url: 'https://track.xiaoshouyi.com/api/ads_pv/',
                type: 'POST',
                data: post_obj
                //dataType: 'json',
                //headers:{'Content-Type': 'application/x-www-form-urlencoded'}
            });
        };
        var cs_o = { 'cs1': 'user_id:${currentUser.id}', 'cs2': 'tenant_id:${pageTenantId}', 'cs4': 'tenant_is_paid:${currentTenant.payStatus == 1}' };
        if (jQuery.cookie('ads_agent_id')) {
            cs_o['cs5'] = 'ads_agent_id:' + jQuery.cookie('ads_agent_id');
        }
        if (jQuery.cookie('ads_keywordid')) {
            cs_o['cs6'] = 'ads_keywordid:' + jQuery.cookie('ads_keywordid');
        }
        var vds_userid = '${userId}' ? '${userId}' : '${data.userId}' ? '${data.userId}' : '';
        if (vds_userid != '') {
            cs_o['cs7'] = 'ads_lead_id:' + vds_userid;
        }
        send_track(cs_o);
    },

    methods: {
        changeContent: function changeContent() {
            if (this.accountStatus) {
                this.page_img = "error";
                this.page_title = "账号已存在";
                this.page_content = this.tel + " 已经是销售易用户，您可以通过销售易APP或网站进行登录。";
            } else {
                this.page_img = "success";
                this.page_title = "提交成功";
                this.page_content = "<p>您已成为仁科互动公司的创建者及管理员，您的登录帐号为" + this.tel + "免费试用时间30天</p> <p>您可以通过销售易APP或者网站进行登录</p>";
            }
        },

        checSystem: function checSystem() {

            var url_ios = 'XSY://';
            var url_ios_download = 'https://itunes.apple.com/cn/app/ingage-crm/id654720925?ls=1&mt=8';
            var url_android = "XSY://com.ingageapp.ingage";
            var url_android_download = 'http://dl.xiaoshouyi.com/apps/android';

            //通过window.navigator.userAgent来判断当前设备是IOS还是Android。


            var u = navigator.userAgent,
                app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isiOS) {
                var loadTime = new Date();
                window.location.href = url_ios;
                setTimeout(function () {
                    var outTime = new Date();
                    if (outTime - loadTime > 800) {
                        window.location.href = url_ios_download;
                    }
                }, 1500);
            }

            if (isAndroid) {

                var loadTime = new Date();

                window.location.href = url_android; /***打开app的协议，有安卓同事提供***/

                setTimeout(function () {
                    var outTime = new Date();
                    if (outTime - loadTime > 800) {
                        window.location.href = url_android_download;
                    }
                }, 1500);
            }
        }
    }

});

/***/ }),

/***/ "rbVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_1_1_13_vux_loader_src_script_loader_js_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("khnd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_ecdea896_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_vux_loader_1_1_13_vux_loader_src_template_loader_js_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("lW0t");
function injectStyle (ssrContext) {
  __webpack_require__("gKqU")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_1_1_13_vux_loader_src_script_loader_js_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_ecdea896_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_1_1_13_vux_loader_src_before_template_compiler_loader_js_vux_loader_1_1_13_vux_loader_src_template_loader_js_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ssoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "syy9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tIiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Xinput',
	props: ['xName', 'xClass', 'xMsg', 'xPlaceholder', 'xType', 'xMaxlength', 'xVal', 'xCola', 'xColb', 'xColc'],

	data: function data() {
		return {
			val: this.xVal,
			icon_remove: false
		};
	},

	created: function created() {},
	methods: {
		//处理手机号表单状态
		blur: function blur() {

			var me = this;
			setTimeout(function () {
				me.icon_remove = false;
				me.$emit('blur', me.val.trim());
			}, 1);
		},
		keyup: function keyup() {
			if (!this.val) {
				this.icon_remove = false;
			} else {
				this.icon_remove = true;
			}
		},
		focus: function focus() {
			if (this.val) {
				this.icon_remove = true;
			}
		},
		onchange: function onchange() {
			this.$emit('input', this.val.trim());
		},
		clear: function clear() {
			this.val = "";
			this.$emit('input', this.val.trim());
			this.$refs.child.focus();
		}

	}
});

/***/ }),

/***/ "xXYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'service',
  data: function data() {
    return {
      //公司名
      cname: "",
      //職位
      job: "",
      //姓名
      name: "",
      //邮箱
      email: "",
      code_value: "",
      tel: ""
    };
  },

  created: function created() {
    //初始化执行的方法
    this.cname = this.$route.params.cname;
    this.job = this.$route.params.job;
    this.name = this.$route.params.name;
    this.email = this.$route.params.email;
    this.code_value = this.$route.params.code_value;
    this.tel = this.$route.params.tel;

    /*    console.log(
          "cname :"+ this.cname +
          "job :"+ this.job +
          "name :"+ this.name +
          "email :"+ this.email +
          "code_value :"+ this.code_value +
          "tel :"+ this.tel
          )*/
  },
  methods: {
    back: function back() {
      this.$router.push({
        name: 'init',
        params: {
          cname: this.cname,
          job: this.job,
          name: this.name,
          email: this.email,
          code_value: this.code_value,
          tel: this.tel
        } });
    }
  }
});

/***/ }),

/***/ "yZtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validate__ = __webpack_require__("E4LH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Xinput_vue__ = __webpack_require__("7Fpb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var count = 60;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  data: function data() {
    var _ref;

    return _ref = {
      //col-12
      col3: "col-3",
      col4: "col-4",
      col5: "col-5",
      col6: "col-6",
      col8: "col-8",
      col9: "col-9",
      col12: "col-12",

      //cols-100
      cols22: "cols-22",
      cols78: "cols-78",

      //电话
      tel: "",
      tel_save: "",
      tel_msg: '',
      tel_name: '手机号',
      tel_class: "form-control",
      tel_Placeholder: "输入手机号",

      //按钮状态 用于表单验证

      submit_btn_disabled: true,
      submit_btn_class: "btn btn-blue",

      //校验码
      verify_name: '校验码',
      verify_Placeholder: "输入右侧字符",
      verify_img: "",
      verify_class: "form-control",
      verify_value: "",
      verify_return: ""
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'verify_class', "form-control"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_name', '验证码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_Placeholder', "输入短信验证码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_class', "form-control"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_btn_value', "获取验证码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_value', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_return', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_lock', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_btn_disabled', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_btn_class', "btn btn-orange"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'code_class', "form-control con-code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sessionId', Date.parse(new Date())), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'time', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'icon_remove', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'type', {
      tel: "tel",
      text: "text",
      email: "email"
    }), _ref;
  },

  created: function created() {

    this.tel = this.$route.params.tel;
    this.getCaptcha();
  },
  components: {
    Xinput: __WEBPACK_IMPORTED_MODULE_2__components_Xinput_vue__["a" /* default */]
  },
  methods: {

    //处理手机号表单状态
    handleTel: function handleTel(str) {
      this.tel = str;

      if (this.tel == "") {
        this.tel_class = "form-control";
        this.tel_msg = "";
      } else if (this.tel.length == "11") {
        if (this.tel_save == "" || this.tel_save == this.tel) {
          //save为空 或者 两者相等
        } else {
          //save不为空 或者 两者不同 -- 刷新验证码清空
          this.sessionId = Date.parse(new Date());
          this.getCaptcha();
          this.verify_value = "";
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(this.tel)) {
          this.tel_class = "form-control";
          this.tel_msg = "";
        } else {
          this.tel_class = "form-control input-error";
          this.tel_msg = "输入的手机号不正确";
        }
        this.doCheck();
      } else {
        this.tel_class = "form-control";
        this.tel_msg = "";
        this.doCheck();
      }
    },
    handleTelBlur: function handleTelBlur(str) {
      var self = this;

      setTimeout(function () {

        self.tel = str;
        if (!self.tel) {
          self.tel = "";
        }

        if (self.tel == "") {
          self.tel_class = "form-control";
          self.tel_msg = "";
        } else {
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(self.tel)) {
            self.tel_class = "form-control";
            self.tel_msg = "";
          } else {
            self.tel_class = "form-control input-error";
            self.tel_msg = "输入的手机号不正确";
          }
          self.doCheck();
        }
      }, 300);
    },
    //处理校验图片状态
    handleVerify: function handleVerify(str) {
      this.verify_value = str;
      if (this.verify_value == "") {
        this.verify_class = "form-control";
        this.verify_return = "";
      } else if (this.verify_value.length == "4") {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value)) {
          this.verify_class = "form-control input-error";
          this.verify_return = "校验码不正确";
        } else {
          this.verify_class = "form-control";
          this.verify_return = "";
        }
        this.doCheck();
      } else {
        this.verify_class = "form-control";
        this.verify_return = "";
        this.doCheck();
      }
    },
    handleVerifyBlur: function handleVerifyBlur(str) {
      this.verify_value = str;
      if (this.verify_value == "") {
        this.verify_class = "form-control";
        this.verify_return = "";
      } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value)) {
          this.verify_class = "form-control input-error";
          this.verify_return = "校验码不正确";
        } else {
          this.verify_class = "form-control";
          this.verify_return = "";
        }
        this.doCheck();
      }
    },
    //处理校验图片状态
    //
    handleCode: function handleCode(str) {
      this.code_value = str;
      if (this.code_value == "") {
        this.code_class = "form-control con-code", this.code_return = "";
      } else if (this.code_value.length == "6") {

        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["a" /* validateCode */])(this.code_value)) {
          this.code_class = "form-control con-code input-error", this.code_return = "短信验证码填写不正确";
        } else {
          this.code_class = "form-control con-code", this.code_return = "";
        }
        this.doCheck();
      } else {
        this.code_class = "form-control con-code", this.code_return = "";
        this.doCheck();
      }
    },
    handleCodeBlur: function handleCodeBlur(str) {
      this.code_value = str;
      if (this.code_value == "") {
        this.code_class = "form-control con-code", this.code_return = "";
      } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["a" /* validateCode */])(this.code_value)) {
          this.code_class = "form-control con-code input-error", this.code_return = "短信验证码填写不正确";
        } else {
          this.code_class = "form-control con-code", this.code_return = "";
        }
        this.doCheck();
      }
    },
    select: function select() {},
    //检查code按钮是否可以点击
    /*  doCodeCheck:function(){
     
        if( validatePhone(this.tel) && validateNull(this.verify_value) && this.code_btn_value =="获取验证码"){
          return true;
    
        }else{
          //this.handleTelphone();
          this.handleVerify()
        }
      },*/
    //检查表单填写完整
    doCheck: function doCheck() {
      //检测获取验证码 状态
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(this.tel) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value) && this.code_lock) {
        this.code_btn_disabled = false;
      } else {
        this.code_btn_disabled = true;
      }
      //检测下一步状态
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(this.tel) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["a" /* validateCode */])(this.code_value)) {
        this.submit_btn_disabled = false;
      } else {
        this.submit_btn_disabled = true;
      }
    },

    times: function times() {
      var self = this;
      var a = setInterval(function () {
        self.code_btn_value = count + "秒";

        count--;
        if (count <= 0) {
          clearInterval(a);
          count = 60;
          self.code_btn_value = "重新发送";
          self.code_btn_disabled = false;
          self.code_lock = true;
        }
      }, 1000);
    },


    getCaptcha: function getCaptcha() {

      /*this.verify_img = this.HOST + '/json/global_register/get-gcaptcha.action?sessionId=' + this.sessionId +'&r='+ Math.random();*/
      this.verify_img = '/json/global_register/get-gcaptcha.action?sessionId=' + this.sessionId + '&r=' + Math.random();

      this.$refs.verify.clear();
      this.doCheck();
    },

    sendCaptch: function sendCaptch() {

      var self = this;

      /*var url = this.HOST + '/json/global_register/validate-gcaptcha.action?loginName='+ this.tel +'&sessionId='+ this.sessionId + '&gcaptcha=' +this.verify_value;*/
      var url = '/json/global_register/validate-gcaptcha.action?loginName=' + this.tel + '&sessionId=' + this.sessionId + '&gcaptcha=' + this.verify_value;
      self.code_btn_disabled = true;
      self.tel_save = self.tel;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(this.tel) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value)) {
        this.submit_btn_value = "再次获取";
        $.ajax({
          url: url,
          type: 'GET',
          timeout: 10000,
          error: function error() {
            self.$vux.toast.show({ text: '连接超时', type: 'text', time: 4000 });
            self.code_btn_disabled = false;
          },
          success: function success(responseText) {
            var status = responseText.status;
            var statusText = responseText.statusText;
            /*
              Result 返回参数说明
              {
                status=0 表示成功 102001 校验码错误，100000 系统异常，101002 图形验证码已失效， 101003 发送失败，101004 频率过多
                 statusText='返回的文案'
              }
            */
            if (status == 102001) {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '校验码错误', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 100000) {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '系统异常', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 101002) {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '图形验证码已失效', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 101003) {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '发送失败', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 101004) {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '频率过多', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 0) {
              self.times();
              self.code_btn_disabled = true;

              //self.$vux.toast.show({text:'开始发送短信倒计时',type:'text',position: 'middle',time:4000});

              self.code_lock = false;
            } else {
              self.code_btn_disabled = false;
              self.$vux.toast.show({ text: '其他', type: 'text', position: 'middle', time: 4000 });
            }
          }
        });
      }
    },

    doSubmit: function doSubmit() {

      //如果没注册去注册，否则去exist
      var telephone = $.trim(this.tel);
      var code_value = $.trim(this.code_value);
      var self = this;
      /*var url = this.HOST + '/json/global_register/submit-loginName.action?loginName='+ telephone +'&captcha='+ code_value;*/
      var url = '/json/global_register/submit-loginName.action?loginName=' + telephone + '&captcha=' + code_value;
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["d" /* validatePhone */])(this.tel) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["f" /* validateVerify */])(this.verify_value) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_validate__["a" /* validateCode */])(this.code_value)) {

        self.submit_btn_disabled = true;

        $.ajax({
          url: url,
          type: 'GET',
          timeout: 10000,
          error: function error() {

            self.$vux.toast.show({ text: '连接超时', type: 'text', time: 4000 });
            self.submit_btn_disabled = false;
          },
          success: function success(responseText) {
            var status = responseText.status;
            var statusText = responseText.statusText;
            //"status": 0 表示成功, 101005 表示验证码失效 ，100000 手机号或者验证码为空，101001 验证码错误
            if (status == 101005) {
              self.submit_btn_disabled = false;
              self.$vux.toast.show({ text: '验证码失效', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 101001) {
              self.submit_btn_disabled = false;
              self.$vux.toast.show({ text: '验证码错误', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 100000) {
              self.submit_btn_disabled = false;
              self.$vux.toast.show({ text: '手机号或者验证码为空', type: 'text', position: 'middle', time: 4000 });
            } else if (status == 0) {

              //"tenants": [] 如果数组为空表示未注册过，反之为注册过
              if (responseText.data.tenants.length > 0) {
                self.$router.push({
                  name: 'exist',
                  params: { tel: self.tel, accountStatus: true }
                });
              } else {
                self.$router.push({
                  name: 'init',
                  params: { tel: self.tel, code_value: self.code_value }
                });
              }
            } else {
              self.submit_btn_disabled = false;
              self.$vux.toast.show({ text: '其他错误', type: 'text', position: 'middle', time: 4000 });
            }
          }
        });
      }
    } } });

/***/ }),

/***/ "ytjV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d25664bff5a03124e033.js